export * from "./types.js";
export * from "./copy.js";
export {
  coContribution,
  coContributionIncomeTestMax,
  spouseOffset,
  carryForwardHeadroom,
  sacrificeTaxSaving,
  assertNoFundHandoff,
} from "./calculate.js";
export { fy2025_26, CONCESSIONAL_CAP_SERIES } from "./fy2025-26.js";
export { fy2026_27 } from "./fy2026-27.js";

import type { FinancialYear } from "../types.js";
import type { SuperBoostRuleSet } from "./types.js";
import { fy2025_26 } from "./fy2025-26.js";
import { fy2026_27 } from "./fy2026-27.js";

/** Registry of super-boost rulesets by financial year. Historical years stay
 * registered so re-runs/amendments resolve against the right rules. */
export const SUPER_BOOST_RULESETS: Record<string, SuperBoostRuleSet> = {
  "2025-26": fy2025_26,
  "2026-27": fy2026_27,
};

/** Resolve the super-boost ruleset for a financial year, or throw if unknown. */
export function superBoostRulesFor(fy: FinancialYear): SuperBoostRuleSet {
  const rules = SUPER_BOOST_RULESETS[fy];
  if (!rules) {
    throw new Error(`no super-boost ruleset registered for FY ${fy}`);
  }
  return rules;
}

/** Most recent super-boost ruleset — the default for live "this year" calcs. */
export const SUPER_BOOST_CURRENT_FY: FinancialYear = "2025-26";
